import React from "react";
import { createRoot } from "react-dom/client";

export function mountApp(AppComponent) {
  const rootEl = document.getElementById("root");
  if (!rootEl) return;
  createRoot(rootEl).render(<AppComponent />);
}

